import { Thread } from "./types";

export default function lastMessagedTime(
  contactId: string,
  messages: Thread["messages"]
): number | null {
  const msg = messages.findLast(m => m.campaignContactId === contactId);
  if (!msg) {
    return null;
  }

  return msg.threadOrderTime;
}
